import React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
export var UnreadDot = function (props) {
    var css = useTheme('Communications').UnreadDot;
    return React.createElement("span", { className: cn(css.unreadDot, props.className) });
};
